// AUTO-GENERERET — kør: npm run dictation:units:en:build
// Verificér før ElevenLabs: npm run dictation:units:en:verify

import type { DictationUnit } from './dictationUnits';

export const DICTATION_UNITS_EN_GENERATED: DictationUnit[] = [
  // --- 2 ord ---
  { id: 'en-p-a-box', text: 'a box', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-cafe', text: 'a cafe', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-camp', text: 'a camp', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-cap', text: 'a cap', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-car', text: 'a car', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-case', text: 'a case', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-cast', text: 'a cast', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-castle', text: 'a castle', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-cat', text: 'a cat', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-chair', text: 'a chair', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-child', text: 'a child', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-clay', text: 'a clay', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-clip', text: 'a clip', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-cod', text: 'a cod', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-coffee', text: 'a coffee', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-cop', text: 'a cop', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-cot', text: 'a cot', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-cow', text: 'a cow', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-cub', text: 'a cub', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-cup', text: 'a cup', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-cur', text: 'a cur', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-cut', text: 'a cut', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-fire', text: 'a fire', wordCount: 2, minTierId: 'niveau-1', tags: ["seed"] },
  { id: 'en-p-a-fix', text: 'a fix', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-flower', text: 'a flower', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-a-fox', text: 'a fox', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-game', text: 'a game', wordCount: 2, minTierId: 'niveau-2', tags: ["seed"] },
  { id: 'en-p-a-gate', text: 'a gate', wordCount: 2, minTierId: 'niveau-1', tags: ["seed"] },
  { id: 'en-p-a-hide', text: 'a hide', wordCount: 2, minTierId: 'niveau-1', tags: ["seed"] },
  { id: 'en-p-a-mix', text: 'a mix', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-name', text: 'a name', wordCount: 2, minTierId: 'niveau-2', tags: ["seed"] },
  { id: 'en-p-a-port', text: 'a port', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-a-post', text: 'a post', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-a-potato', text: 'a potato', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-a-queen', text: 'a queen', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-a-rest', text: 'a rest', wordCount: 2, minTierId: 'niveau-1', tags: ["seed"] },
  { id: 'en-p-a-ride', text: 'a ride', wordCount: 2, minTierId: 'niveau-1', tags: ["seed"] },
  { id: 'en-p-a-side', text: 'a side', wordCount: 2, minTierId: 'niveau-1', tags: ["seed"] },
  { id: 'en-p-a-site', text: 'a site', wordCount: 2, minTierId: 'niveau-1', tags: ["seed"] },
  { id: 'en-p-a-sport', text: 'a sport', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-a-spot', text: 'a spot', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-a-test', text: 'a test', wordCount: 2, minTierId: 'niveau-1', tags: ["seed"] },
  { id: 'en-p-a-text', text: 'a text', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-tile', text: 'a tile', wordCount: 2, minTierId: 'niveau-1', tags: ["seed"] },
  { id: 'en-p-a-tree', text: 'a tree', wordCount: 2, minTierId: 'niveau-1', tags: ["seed"] },
  { id: 'en-p-a-type', text: 'a type', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-a-word', text: 'a word', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-a-zebra', text: 'a zebra', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-zero', text: 'a zero', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-a-zone', text: 'a zone', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-allow-now', text: 'allow now', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-an-ace', text: 'an ace', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-an-idea', text: 'an idea', wordCount: 2, minTierId: 'niveau-2', tags: ["seed"] },
  { id: 'en-p-black-cat', text: 'black cat', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-check-text', text: 'check text', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-check-the-text', text: 'check the text', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'en-p-check-the-text-and-relax', text: 'check the text and relax', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-check-the-text-and-rest', text: 'check the text and rest', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-check-the-text-now', text: 'check the text now', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-drop-now', text: 'drop now', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-exact-text', text: 'exact text', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-extra-text', text: 'extra text', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-fix-box', text: 'fix box', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-fix-now', text: 'fix now', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-fix-the-box', text: 'fix the box', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'en-p-fix-the-box-and-relax', text: 'fix the box and relax', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-fix-the-box-and-rest', text: 'fix the box and rest', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-fix-the-box-now', text: 'fix the box now', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-follow-now', text: 'follow now', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-follow-the-arrow', text: 'follow the arrow', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-free-text', text: 'free text', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-give-now', text: 'give now', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-have-now', text: 'have now', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-he-is', text: 'he is', wordCount: 2, minTierId: 'niveau-1', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-he-is-here', text: 'he is here', wordCount: 3, minTierId: 'niveau-1', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-he-is-here-now', text: 'he is here now', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-hide-now', text: 'hide now', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-it-is', text: 'it is', wordCount: 2, minTierId: 'niveau-1', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-it-is-exact', text: 'it is exact', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-it-is-free', text: 'it is free', wordCount: 3, minTierId: 'niveau-1', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-it-is-free-now', text: 'it is free now', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-it-is-good', text: 'it is good', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-it-is-good-now', text: 'it is good now', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-it-is-here', text: 'it is here', wordCount: 3, minTierId: 'niveau-1', tags: ["seed"] },
  { id: 'en-p-it-is-lazy', text: 'it is lazy', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-it-is-new', text: 'it is new', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-it-is-new-now', text: 'it is new now', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-it-is-nice', text: 'it is nice', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-it-is-nice-now', text: 'it is nice now', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-it-is-quiet', text: 'it is quiet', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-it-is-quiet-now', text: 'it is quiet now', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-it-is-red', text: 'it is red', wordCount: 3, minTierId: 'niveau-1', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-it-is-red-now', text: 'it is red now', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-lazy-cat', text: 'lazy cat', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-live-now', text: 'live now', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-mix-now', text: 'mix now', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-mix-the-words', text: 'mix the words', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'en-p-mix-the-words-and-rest', text: 'mix the words and rest', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-mix-the-words-now', text: 'mix the words now', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-mix-words', text: 'mix words', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-my-idea', text: 'my idea', wordCount: 2, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-never-stop-now', text: 'never stop now', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-next-word', text: 'next word', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-nice-game', text: 'nice game', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-our-game', text: 'our game', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-our-text', text: 'our text', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-read-now', text: 'read now', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-read-text', text: 'read text', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-read-the-text', text: 'read the text', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'en-p-read-the-text-and-rest', text: 'read the text and rest', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-read-the-text-here', text: 'read the text here', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-read-the-text-now', text: 'read the text now', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-red-car', text: 'red car', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-relax-now', text: 'relax now', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-rest-now', text: 'rest now', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-she-is', text: 'she is', wordCount: 2, minTierId: 'niveau-1', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-she-is-here', text: 'she is here', wordCount: 3, minTierId: 'niveau-1', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-she-is-here-now', text: 'she is here now', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-shop-now', text: 'shop now', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-stop-now', text: 'stop now', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-the-ace', text: 'the ace', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-the-box', text: 'the box', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-the-box-is-here', text: 'the box is here', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'en-p-the-box-is-here-now', text: 'the box is here now', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-the-cafe', text: 'the cafe', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-the-camp', text: 'the camp', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-the-cap', text: 'the cap', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-the-car', text: 'the car', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-the-car-is-here', text: 'the car is here', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'en-p-the-car-is-here-now', text: 'the car is here now', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-the-case', text: 'the case', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-the-cast', text: 'the cast', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-the-castle', text: 'the castle', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-the-castle-is-here', text: 'the castle is here', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-the-cat', text: 'the cat', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-the-cat-is-here', text: 'the cat is here', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'en-p-the-cat-is-here-now', text: 'the cat is here now', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-the-chair', text: 'the chair', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-the-chair-is-here', text: 'the chair is here', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-the-child', text: 'the child', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-the-child-is-here', text: 'the child is here', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-the-clay', text: 'the clay', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-the-clip', text: 'the clip', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-the-cod', text: 'the cod', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-the-coffee', text: 'the coffee', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-the-coffee-is-here', text: 'the coffee is here', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-the-cop', text: 'the cop', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-the-cot', text: 'the cot', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-the-cow', text: 'the cow', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-the-cub', text: 'the cub', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-the-cup', text: 'the cup', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-the-cur', text: 'the cur', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-the-cut', text: 'the cut', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-the-fire', text: 'the fire', wordCount: 2, minTierId: 'niveau-1', tags: ["seed"] },
  { id: 'en-p-the-fix', text: 'the fix', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-the-flower', text: 'the flower', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-the-flower-is-here', text: 'the flower is here', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-the-fox', text: 'the fox', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-the-fox-is-here', text: 'the fox is here', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'en-p-the-fox-is-here-now', text: 'the fox is here now', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-the-game', text: 'the game', wordCount: 2, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-the-game-is-here', text: 'the game is here', wordCount: 4, minTierId: 'niveau-2', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-the-gate', text: 'the gate', wordCount: 2, minTierId: 'niveau-1', tags: ["seed"] },
  { id: 'en-p-the-hide', text: 'the hide', wordCount: 2, minTierId: 'niveau-1', tags: ["seed"] },
  { id: 'en-p-the-ice', text: 'the ice', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-the-idea', text: 'the idea', wordCount: 2, minTierId: 'niveau-1', tags: ["seed"] },
  { id: 'en-p-the-mix', text: 'the mix', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-the-name', text: 'the name', wordCount: 2, minTierId: 'niveau-2', tags: ["seed"] },
  { id: 'en-p-the-port', text: 'the port', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-the-post', text: 'the post', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-the-potato', text: 'the potato', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-the-potato-is-here', text: 'the potato is here', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-the-queen', text: 'the queen', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-the-queen-is-here', text: 'the queen is here', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-the-rest', text: 'the rest', wordCount: 2, minTierId: 'niveau-1', tags: ["seed"] },
  { id: 'en-p-the-ride', text: 'the ride', wordCount: 2, minTierId: 'niveau-1', tags: ["seed"] },
  { id: 'en-p-the-side', text: 'the side', wordCount: 2, minTierId: 'niveau-1', tags: ["seed"] },
  { id: 'en-p-the-site', text: 'the site', wordCount: 2, minTierId: 'niveau-1', tags: ["seed"] },
  { id: 'en-p-the-sport', text: 'the sport', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-the-spot', text: 'the spot', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-the-test', text: 'the test', wordCount: 2, minTierId: 'niveau-1', tags: ["seed"] },
  { id: 'en-p-the-text', text: 'the text', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-the-tile', text: 'the tile', wordCount: 2, minTierId: 'niveau-1', tags: ["seed"] },
  { id: 'en-p-the-tree', text: 'the tree', wordCount: 2, minTierId: 'niveau-1', tags: ["seed"] },
  { id: 'en-p-the-type', text: 'the type', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-the-word', text: 'the word', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-the-zebra', text: 'the zebra', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-the-zebra-is-here', text: 'the zebra is here', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-the-zero', text: 'the zero', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-the-zone', text: 'the zone', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-type-now', text: 'type now', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-type-text', text: 'type text', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-type-the-text', text: 'type the text', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-type-the-text-here', text: 'type the text here', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-type-the-text-now', text: 'type the text now', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-we-are', text: 'we are', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-we-are-here', text: 'we are here', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-we-are-here-now', text: 'we are here now', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'en-p-we-can-check-the-text', text: 'we can check the text', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-we-can-fix-the-box', text: 'we can fix the box', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'en-p-we-can-fix-the-box-now', text: 'we can fix the box now', wordCount: 6, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'en-p-we-can-mix-the-words', text: 'we can mix the words', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'en-p-we-can-mix-the-words-now', text: 'we can mix the words now', wordCount: 6, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'en-p-we-can-read-the-text', text: 'we can read the text', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'en-p-we-can-read-the-text-now', text: 'we can read the text now', wordCount: 6, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'en-p-we-can-type-the-text', text: 'we can type the text', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 6+ (7–12 ord) ---
  { id: 'en-s-we-can-type-the-text-here-now', text: 'we can type the text here now', wordCount: 7, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'en-p-we-can-type-the-text-now', text: 'we can type the text now', wordCount: 6, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-we-read-now', text: 'we read now', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-we-rest-now', text: 'we rest now', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-we-type-now', text: 'we type now', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-write-text', text: 'write text', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-write-the-text', text: 'write the text', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-write-the-text-now', text: 'write the text now', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-you-are', text: 'you are', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-you-are-here', text: 'you are here', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-you-are-here-now', text: 'you are here now', wordCount: 4, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-you-can-allow', text: 'you can allow', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-you-can-allow-now', text: 'you can allow now', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-you-can-check', text: 'you can check', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-you-can-check-now', text: 'you can check now', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'en-p-you-can-check-the-text', text: 'you can check the text', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 6+ (7–12 ord) ---
  { id: 'en-s-you-can-check-the-text-and-relax-now', text: 'you can check the text and relax now', wordCount: 8, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'en-p-you-can-check-the-text-now', text: 'you can check the text now', wordCount: 6, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-you-can-drop', text: 'you can drop', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-you-can-fix', text: 'you can fix', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-you-can-fix-now', text: 'you can fix now', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'en-p-you-can-fix-the-box', text: 'you can fix the box', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 6+ (7–12 ord) ---
  { id: 'en-s-you-can-fix-the-box-and-relax-now', text: 'you can fix the box and relax now', wordCount: 8, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'en-p-you-can-fix-the-box-now', text: 'you can fix the box now', wordCount: 6, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'en-p-you-can-fix-the-word', text: 'you can fix the word', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-you-can-follow', text: 'you can follow', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-you-can-follow-now', text: 'you can follow now', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'en-p-you-can-follow-the-arrow', text: 'you can follow the arrow', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-you-can-mix', text: 'you can mix', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-you-can-mix-now', text: 'you can mix now', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'en-p-you-can-mix-the-word', text: 'you can mix the word', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-you-can-mix-the-words', text: 'you can mix the words', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 6+ (7–12 ord) ---
  { id: 'en-s-you-can-mix-the-words-in-order', text: 'you can mix the words in order', wordCount: 7, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'en-p-you-can-mix-the-words-now', text: 'you can mix the words now', wordCount: 6, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-you-can-mix-words-and-relax', text: 'you can mix words and relax', wordCount: 6, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-you-can-quote', text: 'you can quote', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'en-p-you-can-quote-the-text', text: 'you can quote the text', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-you-can-read', text: 'you can read', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-you-can-read-now', text: 'you can read now', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'en-p-you-can-read-the-text', text: 'you can read the text', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 6+ (7–12 ord) ---
  { id: 'en-s-you-can-read-the-text-here-now', text: 'you can read the text here now', wordCount: 7, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'en-p-you-can-read-the-text-now', text: 'you can read the text now', wordCount: 6, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'en-p-you-can-read-the-word', text: 'you can read the word', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'en-p-you-can-read-the-word-now', text: 'you can read the word now', wordCount: 6, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-you-can-relax', text: 'you can relax', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-you-can-relax-now', text: 'you can relax now', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-you-can-rest', text: 'you can rest', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-you-can-rest-now', text: 'you can rest now', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-you-can-shop', text: 'you can shop', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-you-can-stop', text: 'you can stop', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-you-can-stop-now', text: 'you can stop now', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-you-can-type', text: 'you can type', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'en-p-you-can-type-fast-and-relax', text: 'you can type fast and relax', wordCount: 6, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-you-can-type-now', text: 'you can type now', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 6+ (7–12 ord) ---
  { id: 'en-s-you-can-type-the-extra-text-now', text: 'you can type the extra text now', wordCount: 7, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'en-p-you-can-type-the-text', text: 'you can type the text', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'en-p-you-can-type-the-text-now', text: 'you can type the text now', wordCount: 6, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'en-p-you-can-type-the-word', text: 'you can type the word', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'en-p-you-can-type-the-word-now', text: 'you can type the word now', wordCount: 6, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-you-can-write', text: 'you can write', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 4 ord ---
  { id: 'en-p-you-can-write-now', text: 'you can write now', wordCount: 4, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 6+ (7–12 ord) ---
  { id: 'en-s-you-can-write-the-next-word-now', text: 'you can write the next word now', wordCount: 7, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'en-p-you-can-write-the-text', text: 'you can write the text', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'en-p-you-can-write-the-text-now', text: 'you can write the text now', wordCount: 6, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 5 ord ---
  { id: 'en-p-you-can-write-the-word', text: 'you can write the word', wordCount: 5, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 6 ord ---
  { id: 'en-p-you-can-write-the-word-now', text: 'you can write the word now', wordCount: 6, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 3 ord ---
  { id: 'en-p-you-check-now', text: 'you check now', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-you-fix-now', text: 'you fix now', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-you-mix-now', text: 'you mix now', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-you-read-now', text: 'you read now', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-you-relax-now', text: 'you relax now', wordCount: 3, minTierId: 'niveau-4', tags: ["seed"] },
  { id: 'en-p-you-rest-now', text: 'you rest now', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-you-type-now', text: 'you type now', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-you-write-now', text: 'you write now', wordCount: 3, minTierId: 'niveau-3', tags: ["seed"] },
  // --- 2 ord ---
  { id: 'en-p-your-name', text: 'your name', wordCount: 2, minTierId: 'niveau-3', tags: ["seed"] },
  { id: 'en-p-your-text', text: 'your text', wordCount: 2, minTierId: 'niveau-4', tags: ["seed"] },
  // --- 1 ord ---
  { id: 'en-w-about', text: 'about', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'en-w-above', text: 'above', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'en-w-ad', text: 'ad', wordCount: 1, minTierId: 'grundniveau', tags: ["word"] },
  { id: 'en-w-add', text: 'add', wordCount: 1, minTierId: 'grundniveau', tags: ["word"] },
  { id: 'en-w-around', text: 'around', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'en-w-baby', text: 'baby', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'en-w-below', text: 'below', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'en-w-borrow', text: 'borrow', wordCount: 1, minTierId: 'niveau-3', tags: ["word"] },
  { id: 'en-w-boxes', text: 'boxes', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-breeze', text: 'breeze', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-byte', text: 'byte', wordCount: 1, minTierId: 'niveau-2', tags: ["word"] },
  { id: 'en-w-cab', text: 'cab', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-camel', text: 'camel', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-canal', text: 'canal', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-cancel', text: 'cancel', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-cancer', text: 'cancer', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-candy', text: 'candy', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-canvas', text: 'canvas', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-carbon', text: 'carbon', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-career', text: 'career', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-cargo', text: 'cargo', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-carpet', text: 'carpet', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-carrot', text: 'carrot', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-casino', text: 'casino', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-catalog', text: 'catalog', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-catch', text: 'catch', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-cattle', text: 'cattle', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-causal', text: 'causal', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-cause', text: 'cause', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-cavity', text: 'cavity', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-cellar', text: 'cellar', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-cement', text: 'cement', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-center', text: 'center', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-central', text: 'central', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-cereal', text: 'cereal', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-chain', text: 'chain', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-chalk', text: 'chalk', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-chance', text: 'chance', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-change', text: 'change', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-charge', text: 'charge', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-charm', text: 'charm', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-chart', text: 'chart', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-chase', text: 'chase', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-cheap', text: 'cheap', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-cheer', text: 'cheer', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-cherry', text: 'cherry', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-chess', text: 'chess', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-chest', text: 'chest', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-chief', text: 'chief', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-chill', text: 'chill', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-china', text: 'china', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-chip', text: 'chip', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-choice', text: 'choice', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-choose', text: 'choose', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-chord', text: 'chord', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-chose', text: 'chose', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-chrome', text: 'chrome', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-cinema', text: 'cinema', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-circle', text: 'circle', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-citizen', text: 'citizen', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-citron', text: 'citron', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-citrus', text: 'citrus', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-civic', text: 'civic', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-civil', text: 'civil', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-claim', text: 'claim', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-clamp', text: 'clamp', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-clash', text: 'clash', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-clasp', text: 'clasp', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-class', text: 'class', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-claw', text: 'claw', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-clear', text: 'clear', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-clerk', text: 'clerk', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-click', text: 'click', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-client', text: 'client', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-cliff', text: 'cliff', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-climb', text: 'climb', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-cling', text: 'cling', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-clinic', text: 'clinic', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-clock', text: 'clock', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-clone', text: 'clone', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-close', text: 'close', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-closet', text: 'closet', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-cloth', text: 'cloth', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-cloud', text: 'cloud', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-clown', text: 'clown', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-coach', text: 'coach', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-coast', text: 'coast', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-cobra', text: 'cobra', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-collar', text: 'collar', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-colon', text: 'colon', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-color', text: 'color', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-column', text: 'column', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-combat', text: 'combat', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-combo', text: 'combo', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-comet', text: 'comet', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-comic', text: 'comic', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-comma', text: 'comma', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-commit', text: 'commit', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-common', text: 'common', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-compel', text: 'compel', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-complex', text: 'complex', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-condo', text: 'condo', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-context', text: 'context', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-convey', text: 'convey', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-copper', text: 'copper', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-coral', text: 'coral', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-corner', text: 'corner', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-cosmic', text: 'cosmic', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-costly', text: 'costly', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-cotton', text: 'cotton', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-couch', text: 'couch', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-cough', text: 'cough', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-could', text: 'could', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-count', text: 'count', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-couple', text: 'couple', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-course', text: 'course', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-court', text: 'court', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-cousin', text: 'cousin', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-cover', text: 'cover', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
  { id: 'en-w-coy', text: 'coy', wordCount: 1, minTierId: 'niveau-4', tags: ["word"] },
];
